import * as React from "react";
import { defaultValues, toSelectOptions } from "../../../services/defaults";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";

interface Props {
  index: number;
}
export const Logzio: React.FC<Props> = ({ index }) => {
  const df = defaultValues.org.logging.logzio;

  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.logzio.listenerHost`}>Listener Host</CpLabel>
          <CpSelect
            name={`logging.${index}.logzio.listenerHost`}
            options={toSelectOptions(df.listenerHost.options)}
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.logzio.listenerHost`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.logzio.credentials`}>Credentials</CpLabel>
          <CpDescription>Select an Opaque secret to access logzio</CpDescription>
          <CpKindSelect
            kind="secret"
            queries={[{ property: "type", value: "opaque" }]}
            name={`logging.${index}.logzio.credentials`}
            optionValue="name"
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.logzio.credentials`} />
        </CpFormItem>
      </div>
    </>
  );
};
